/**
 * Initialize Video Control for embed videos
 */

jQuery(document).ready(function ($) {
  if (!$('.has-cover-image').length) {
    return;
  }

  $('.has-cover-image').click(function () {
    $(this).addClass('playing');

    // Handle native video elements
    if ($(this).children('video').length) {
      $(this).children('video').get(0).play();
    }

    // Handle lite-youtube elements
    if ($(this).find('lite-youtube').length) {
      var liteYT = $(this).find('lite-youtube').get(0);
      // Trigger click to activate lite-youtube (loads iframe with autoplay)
      if (!liteYT.classList.contains('lyt-activated')) {
        liteYT.click();
      }
    }

    // Handle regular iframes (Vimeo, other embeds)
    if ($(this).find('iframe').length) {
      var videoSrc = $(this).find('iframe').attr('src');
      if (videoSrc && videoSrc.indexOf('autoplay=1') === -1) {
        $(this)
          .find('iframe')
          .attr(
            'src',
            videoSrc + (videoSrc.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1'
          );
      }
    }
  });
});
